<template>
  <div>
    <h2>Subscribed E-mail</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div class="d-flex justify-end px-5" style="gap: 12px">
      <div style="min-width: 166px;">
        <submit-button label="Export Excel" @click.native="exportExcel"/>
        <div class="mt-5" style="font-size: 14px">จำนวนทั้งหมด {{ dataPaginate.total }} รายการ</div>
      </div>

      <div>
        <date-picker
            :model="search.start_date"
            label="Start date"
            style="max-width: 180px"
            @update="search.start_date = $event; getSearchSubscriber()"
            @onClear="search.start_date = undefined; getSearchSubscriber()"
        ></date-picker>
        <date-picker
            :model="search.end_date"
            label="End date"
            style="max-width: 180px"
            @update="search.end_date = $event; getSearchSubscriber()"
            @onClear="search.end_date = undefined; getSearchSubscriber()"
        ></date-picker>
      </div>

      <div style="max-width: 240px">
        <v-select
            :items="allCategories"
            background-color="#ffffff"
            item-text="name_en"
            item-value="name_en"
            menu-props="offsetY"
            label="Category"
            outlined
            multiple
            :value="search.category"
            @change="search.category = $event; getSearchSubscriber()"
            style="border-radius: 30px; text-align: left!important;"
            clearable
            @click:clear="search.category = []; getSearchSubscriber()"
            dense
        >
          <template v-slot:prepend-item>
            <div class="pa-3">
              <v-btn
                  small
                  flat
                  style="text-transform: unset"
                  @click="selectAllCates"
              >
                {{ search.category && (search.category.length !== allCategories.length) ? 'Select All' : 'Deselect All' }}
              </v-btn>
            </div>
          </template>
        </v-select>
      </div>

      <InputTextField
          label="Search email"
          :model="search.email"
          @update="search.email = $event"
          @onEnter="getSearchSubscriber"
      ></InputTextField>
    </div>

    <v-simple-table class="branch-data">
      <template v-slot:default>
        <thead>
        <tr>
          <th
              v-for="header in headers"
              :key="header.id"
              class="text-center"
          >
            {{ header }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in dataTable"
            :key="index"
        >
          <td>{{ ((dataPaginate.current_page-1)*10) + (index+1) }}</td>
          <td>{{ item.updated_at | moment("DD/MM/YYYY") }}</td>
          <td>{{ item.email }}</td>
          <td>
            <div
                class="interested-box"
                style="max-height: 180px; display: flex; flex-direction: column; flex-wrap: wrap; gap: 8px; overflow: auto"
            >
              {{ item.interested_in.join(', ') }}
<!--              <div-->
<!--                  v-for="(title, ind) in item.interested_in"-->
<!--                  :key="ind"-->
<!--              >-->
<!--                - {{ title }}-->
<!--              </div>-->
            </div>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <paginate v-if="dataPaginate"
              :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="getSearchSubscriber">
    </paginate>
  </div>
</template>

<script>
import Paginate from "@/components/Layout/Paginate"
import Loading from "vue-loading-overlay"
import IconPencil from "../../components/Icon/icon-pencil"
import moment from "moment"
import InputTextField from "@/components/Input/InputTextField"
import DatePicker from "@/components/Input/DatePicker"
import SubmitButton from "@/components/Button/SubmitButton"
import Swal from "sweetalert";
import {domain} from "@/util/Constants";

export default {
  name: "SubscribeEmailTable",
  components: {
    Loading,
    Paginate,
    IconPencil,
    InputTextField,
    DatePicker,
    SubmitButton
  },
  data () {
    return {
      moment,
      isLoading: false,
      headers: [
        "No.",
        "Date",
        "Subscribed Mail",
        "Categories (ฉันสนใจใน)"
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1
      },
      allCategories: [],
      search: {
        email: '',
        category: [],
        start_date: undefined,
        end_date: undefined
      }
    }
  },
  async created() {
    this.getSearchSubscriber()

    let allCates = await this.$store.dispatch('SupportContact/getEnewsletterCategories')
    if (allCates && allCates.result) {
      this.allCategories = allCates.result
    }
  },
  methods: {
    async getSearchSubscriber (page = 1) {
      this.isLoading = true
      let res = await this.$store.dispatch('SupportContact/getEnewsletterSubscribe', {
        page,
        ...this.search,
        category: this.search.category.join(',').replace(/&/g, 'S_AMPERSAND')
      })
      console.log(res)
      if (res && res.result) {
        this.dataPaginate = res.result
        this.dataTable = res.result.data
      }
      this.isLoading = false
    },
    exportExcel(){
      if (!this.search.start_date || !this.search.end_date) {
        Swal('','กรุณาเลือกวันที่ให้ครบ','error');
      } else {
        if (this.dataTable.length === 0) {
          Swal('','ไม่พบรายการข้อมูล','error');
          return
        }
        let start_date = this.search.start_date ? moment(this.search.start_date).format("YYYY-MM-DD") : '';
        let end_date = this.search.start_date ? moment(this.search.end_date).format("YYYY-MM-DD") : '';
        let category = this.search.category.join(',').replace(/&/g, 'S_AMPERSAND')
        window.open(`${domain}/excel/excel_subscribe?start_date=${start_date}&end_date=${end_date}&email=${this.search.email}&category=${category}`)
      }
    },
    selectAllCates () {
      if (this.search.category && (this.search.category.length !== this.allCategories.length)) {
        this.search.category = this.allCategories.map(x => x.name_en)
      } else {
        this.search.category = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
.interested-box {
  scrollbar-width: none;
}

.interested-box::-webkit-scrollbar {
  display: none;
}
</style>